<p class="wrap-long-text">{{ comment.text }}</p>
<small>
  {{
    'DOCUMENTS.file-manager.comments.comment-meta'
      | translate: { name: comment.createdBy.name, datetime: comment.createdOn | date: 'medium' }
  }}
</small>
<button
  *ngIf="comment.createdBy.id === currentUserId"
  type="button"
  mat-icon-button
  [matTooltip]="'shared.delete' | translate"
  [attr.aria-label]="'shared.delete' | translate"
  (click)="showDeleteCommentDialog()"
  [appLoadingButton]="deletePendingFlag.isPending()"
>
  <mat-icon svgIcon="delete" />
</button>
